import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { type ReactNode, useId } from 'react';
import { sectionSx } from './OpenXAgentPanelSection.styles.ts';

type OpenXAgentPanelSectionProps = {
  title: ReactNode;
  children: ReactNode;
};

export const OpenXAgentPanelSection = ({ title, children }: OpenXAgentPanelSectionProps) => {
  const titleId = useId();

  return (
    <Box component="section" aria-labelledby={titleId} sx={sectionSx}>
      <Typography id={titleId} variant="h2" component="h3" sx={{ m: 0, color: 'text.primary' }}>
        {title}
      </Typography>

      {children}
    </Box>
  );
};
